import ko from './ko';

const currentLanguage = ko;

export default currentLanguage;